import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Tab, Card, Spinner, Button } from "react-bootstrap";
import Block from "../../components/Block/Block";
import { connect } from "react-redux";
import { Icon } from "../../components";
import { getRouteApi } from "../../services/TransportService";
import { getFormattedDuration } from "../../utilities";
import TripList from "./Trip/TripList";
import Routemap from "./Routemap";
function RouteDetailsPage({ userRole }) {
  const { id } = useParams();
  const [route, setRoute] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [mapdialog, setMapdisalog] = useState(false);
  const handlMapDialog = () => {
    setMapdisalog(!mapdialog);
  };
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRoute = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getRouteApi(id);
        setRoute(response?.data);
      } catch (err) {
        setError(
          err?.reseponse?.data?.message ||
            err?.response?.data?.error ||
            "An error occurred while fetching route data."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchRoute();
  }, [id]);

  if (loading)
    return (
      <div className="text-center my-4">
        <Spinner animation="border" variant="primary" />
      </div>
    );

  return (
    <div>
      {error ? (
        <div className="alert alert-danger m-2">{error}</div>
      ) : (
        <div className="card">
          <div className="row px-2">
            <div className="col-12 col-md-4 border-end p-4">
              <div className="bio-block">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex aligm-items-center">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm btn-circle"
                      onClick={() => navigate("/routes")}
                    >
                      <Icon name="arrow-left"></Icon>
                    </button>
                    <h4 className="bio-block-title mx-3">Route Details</h4>
                  </div>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => navigate(`/route/${id}/edit`)}
                  >
                    <Icon name="edit" />
                    <span>Edit</span>
                  </Button>
                </div>

                <ul className="list-group list-group-borderless small mt-2">
                  <li className="list-group-item">
                    <span className="title fw-medium w-40 d-inline-block">
                      Name:
                    </span>
                    <span className="text">{route?.name}</span>
                  </li>

                  <li className="list-group-item">
                    <span className="title fw-medium w-40 d-inline-block">
                      Route Number:
                    </span>
                    <span className="text">{route?.route_number}</span>
                  </li>

                  <li className="list-group-item">
                    <span className="title fw-medium w-40 d-inline-block">
                      Status:
                    </span>
                    <span
                      className={`badge small text-bg-${
                        route?.is_active ? "success" : "danger"
                      }-soft`}
                    >
                      {route?.is_active ? "Active" : "Inactive"}
                    </span>
                  </li>
                </ul>
              </div>
              <div className="bio-block border-top">
                <div className="d-flex justify-content-between mb-2">
                  <div className="d-flex flex-column gap-1">
                    <h4 className="bio-block-title p-0 m-0">Route Stops</h4>
                    <span className="small" style={{fontSize:'0.75rem'}}>
                     (Duration:{" "}
                      {route?.total_travel_duration
                        ? `${route.total_travel_duration} min`
                        : "N/A"})
                    </span>
                  </div>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm btn-circle align-self-start"
                    onClick={handlMapDialog}
                  >
                    View in Map
                  </button>
                </div>
                {route?.stop_sequence?.length > 0 ? (
                  <div className="route-stop-list">
                    {route?.stop_sequence?.map((stop, index) => (
                      <div key={index} className="route-stop">
                        <div className="timeline">
                          <span className="stop-pin">
                            <span className="stop-order">{stop?.order}</span>
                          </span>
                          {index !== route?.stop_sequence.length - 1 && (
                            <span className="line" />
                          )}
                        </div>
                        <div className="stop-data">
                          <span
                            className="stop-name"
                            style={{ fontSize: "0.9rem" }}
                          >
                            {stop?.stop?.name}
                            <br></br>
                            <span
                              className="badge text-bg-info-soft"
                              style={{ fontSize: "0.7rem" }}
                            >
                              Arrive:
                              {stop?.travel_time_duration_from_prev_stop
                                ? getFormattedDuration(
                                    stop?.travel_time_duration_from_prev_stop
                                  )
                                : "N/A"}
                            </span>
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-danger text-center">
                    No stops assigned to this route.
                  </p>
                )}
              </div>
            </div>
            <div className="col-12 col-md-8 p-0">
              <TripList
                routeName={route?.name}
                routeId={id}
                endtime={route?.total_travel_duration}
              />
            </div>
          </div>
        </div>
      )}
      <Routemap id={id} open={mapdialog} handleclose={handlMapDialog} />
    </div>
  );
}

const mapStateToProps = (state) => ({
  userRole: state.auth.user?.role || "user",
});

export default connect(mapStateToProps)(RouteDetailsPage);
